import React, { ReactNode } from "react";
import AppTooltip from "./AppTooltip";

type PROPS = {
  label?: string;
  required?: boolean;
  children?: ReactNode;
  tooltip?: string;
};

const FormItem: React.FC<PROPS> = (props) => {
  return (
    <div className="flex justify-between items-center min-h-[3rem]">
      <div className="w-3/12 flex justify-between">
        {props.label}
        {props.required && <span className="ml-2 mr-auto text-red-500 font-bold">*</span>}
        <AppTooltip tooltip={props.tooltip} />
      </div>
      <div className="w-9/12">{props.children}</div>
    </div>
  );
};

export default FormItem;
